import i18n from "../language/index";

export default {
  createToast(key, type, timeout = 4000) {
    const { t } = i18n.global;
    return {
      title: t(`${key}.title`),
      message: t(`${key}.message`),
      type: type,
      timeout: timeout,
    };
  },
};
